import { GET_ANPRS } from "../actions/types.js";

const initialState = {
    anprs: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ANPRS:
            return {
                ...state,
                anprs: action.payload
            };
        default:
            return state;
    }
}

